module.exports = __webpack_public_path__ + "static/media/CEA_TAUXCONDITIONS_01.04.2024.5190d752.pdf";